import RichText from "@/components/RichText";

// Repli tant que l'API n'a pas répondu (blocks === undefined) — même logique
// que ServicesSection/FeatureGridSection. Une section présente mais vide
// (blocks === []) n'affiche aucune ligne, jamais ce repli.
const FALLBACK_BLOCKS = [
  { id: "fallback-1", props: { title: "Une prestation", desc: "Décrivez ici ce qu'elle comprend.", price: "25", note: "" } },
  { id: "fallback-2", props: { title: "Une autre prestation", desc: "Décrivez ici ce qu'elle comprend.", price: "40", note: "" } },
  { id: "fallback-3", props: { title: "Une formule complète", desc: "Décrivez ici ce qu'elle comprend.", price: "60", note: "à partir de" } },
];

const DEFAULTS = { eyebrow: "", heading: "Notre carte", subheading: "", currency: "€", variant: "light", anchor_id: "" };

export default function PriceListSection({ props = {}, blocks }) {
  const t = { ...DEFAULTS, ...props };
  const rows = (blocks === undefined ? FALLBACK_BLOCKS : blocks).filter((b) => b.enabled !== false);
  const dark = t.variant === "dark";
  if (!rows.length && !t.heading) return null;

  return (
    <section
      id={t.anchor_id || undefined}
      data-testid="price-list-section"
      className={`scroll-mt-28 ${dark ? "bg-ink" : ""}`}
    >
      <div className="max-w-[900px] mx-auto px-6 md:px-10 py-20 md:py-28 scroll-mt-28">
        {(t.eyebrow || t.heading || t.subheading) && (
          <div className="text-center max-w-2xl mx-auto mb-12">
            {t.eyebrow && (
              <RichText
                as="span"
                className={`inline-flex items-center gap-1.5 rounded-full border px-3.5 py-1.5 text-[12px] font-semibold tracking-wide uppercase mb-4 ${
                  dark ? "border-white/15 bg-white/5 text-gold" : "border-stone bg-sand text-gold"
                }`}
                html={t.eyebrow}
              />
            )}
            {t.heading && (
              <RichText
                as="h2"
                className={`font-display font-semibold text-[30px] md:text-[34px] leading-tight tracking-[-0.02em] ${dark ? "text-white" : "text-ink"}`}
                html={t.heading}
              />
            )}
            {t.subheading && (
              <RichText as="p" preserveParagraphs className={`text-[16px] mt-4 ${dark ? "text-white/60" : "text-graphite"}`} html={t.subheading} />
            )}
          </div>
        )}

        <ul className={`divide-y ${dark ? "divide-white/10" : "divide-stone"}`}>
          {rows.map((block) => {
            const price = (block.props?.price || "").toString().trim();
            const note = (block.props?.note || "").toString().trim();
            return (
              <li
                key={block.id}
                data-block-key={block.id}
                className="flex items-start justify-between gap-6 py-4"
              >
                <div className="min-w-0">
                  {block.props?.title && (
                    <RichText
                      as="h3"
                      className={`font-display font-semibold text-[17px] leading-snug ${dark ? "text-white" : "text-ink"}`}
                      html={block.props.title}
                    />
                  )}
                  {block.props?.desc && (
                    <p className={`text-[14px] mt-1 leading-relaxed ${dark ? "text-white/60" : "text-graphite"}`}>{block.props.desc}</p>
                  )}
                </div>
                {price && (
                  <div className="text-right shrink-0">
                    {note && <div className={`text-[11px] uppercase tracking-wide ${dark ? "text-white/40" : "text-ash"}`}>{note}</div>}
                    <div className="text-gold font-display font-semibold text-[18px] whitespace-nowrap">
                      {price}
                      <span className="ml-0.5">{t.currency}</span>
                    </div>
                  </div>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
